<template>
  <el-row :gutter="20">
    <el-col
      :xs="24"
      :sm="24"
      :md="24"
      :lg="12"
      :xl="12"
    >
      <div class="heading">
        <h1>
          Set Theme/Skin
        </h1>
      </div>
    </el-col>
    </el-row>
  <el-row :gutter="20">
    <el-col
      :xs="24"
      :sm="24"
      :md="24"
      :lg="24"
      :xl="24"
    >
      <div v-if="showAlertAdded">
        <el-alert
          v-if="!themeId"
          title="Theme Added Successfully"
          type="success"
          effect="dark"
        />
        <el-alert
          v-if="themeId"
          title="Theme Updated Successfully"
          type="success"
          effect="dark"
        />
      </div>
     
    </el-col>
  </el-row>

  <el-form
    ref="ruleForm"
    :model="data"
    status-icon
    :rules="rules"
    label-width="180px"
    class=" login-form"
    :label-position="labelPosition" 
  >
    <el-row :gutter="20">
	<el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6"><el-form-item
		label="Select Theme"
		prop="skin_id"
		>
		<el-select v-model="data.skin_id"  placeholder="Select Theme" >
            <el-option
			v-for="item in themes"
			:key="item.value"
			:value="item.value"
			:label="item.label"
			@click="getTheme(item.value)"
			></el-option>
          </el-select>
		</el-form-item></el-col>
		<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-if="data.preview_img !== null">
        <div>
          <h5 class="fl-left el-form-item__label" style="margin: 0 10px 0 0;">Preview</h5>
          <img v-if="data.preview_img !== null"
               :src="data.preview_img" style="max-height: 300px">
          <el-skeleton-item v-if="data.preview_img === null" variant="image" style="height: 300px;border:solid 1px;background-color: #FAFAFA;border-color: lightgray" />
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col
        :xs="24"
        :sm="24"
        :md="24"
        :lg="12"
        :xl="12"
      >
        <el-form-item>
          
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >
            Submit
          </el-button>
          <el-button  v-if="!themeId" @click="resetForm('ruleForm')">
            Reset
          </el-button>
        </el-form-item>
      </el-col>
    </el-row>

 </el-form>
</template>
<script>

import ThemeService from "@/api/theme.service";
export default {
  data() {
      return {
        showAlertAdded: false,
        labelPosition: 'top',
        themeId: this.$route.params.themeId,   
        themes:[],		
        data: {
          skin_id: null,
          preview_img:null
        }
      };
    },
	mounted() {
	this.getUserWebsite();   
	this.getthemes();   
  }, 
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
             return ThemeService.setThemeskin(this.data).then(response => {
                this.showAlertAdded=true ;
                return response;
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },  
      getTheme(themeId=null){
        return ThemeService.getTheme(themeId).then(response => {
			this.data.skin_id		= response.data.data[0].value;
            this.data.preview_img	= response.data.data[0].preview_img;
          });
      }, 
	 getUserWebsite() {
          return ThemeService.getUserWebsite().then(response => { 
			 this.getTheme(response.data.data[0].skin_id);
          });
       },
	 getthemes(){		   
		return ThemeService.getThemesList().then(response => {
			//response.data.data.push({label:'Deffult', value: '7'});
			this.themes=response.data.data;
		});
	  }
  }
}
</script>
<style lang="scss">
.el-checkbox{
  width: 20%;
  text-transform: capitalize;
}
.el-select-dropdown{
      text-transform: capitalize;
}
.el-select .el-input__inner{
  text-transform: capitalize;
}
</style>
<style lang="scss" scoped>
.el-form--label-top .el-form-item__label{
      float: left !important;
      font-weight: 500;
      font-size: 12px;
      padding: 0 0 0px 0;
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }  
  .heading {
  text-align: left;
  width: 100%;
  line-height: 2;
}
    .login {
        flex: 1;
		width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
   .login-form {
        width: 100%;
    }
    .selectstatus{
      -webkit-appearance: none;
    background-color: #FFFFFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
    }
div .topsearch {
    float: right;
    display: inline-flex;
    padding: 15px 0px;
  }
div .topsearch .el-input__inner{
  padding-right:10px;
  height: 40px;
  width: 500px;
}
div .topsearch .el-input{
  padding-right:10px;
}
.pagination{ 
  padding: 12px 5px;
  float: right;
}
</style>
